import { render, staticRenderFns } from "./ordingCard.vue?vue&type=template&id=3a4a17ac&scoped=true"
import script from "./ordingCard.vue?vue&type=script&lang=js"
export * from "./ordingCard.vue?vue&type=script&lang=js"
import style0 from "./ordingCard.vue?vue&type=style&index=0&id=3a4a17ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4a17ac",
  null
  
)

export default component.exports